import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { CheckCircle, Building2 } from 'lucide-react';

export default function LandingPricing({ onRegisterClick, onEnterpriseClick }) {
  const { t } = useTranslation();
  return (
    <section id="pricing" className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t('landing.pricing.title')}
          </h2>
          <p className="text-lg max-w-3xl mx-auto text-brand-ink">
            {t('landing.pricing.offer')}
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* $10/RFP Plan */}
          <div className="bg-white rounded-lg p-8 shadow-lg border border-border">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold mb-2 text-foreground">
                {t('landing.pricing.payg.name')}
              </h3>
              <div className="text-5xl font-bold mb-2 text-foreground">
                {t('landing.pricing.payg.price')}
              </div>
              <p className="text-muted-foreground">{t('landing.pricing.payg.period')}</p>
            </div>
            <ul className="space-y-4 mb-8">
              {[1,2,3,4,5].map((n) => {
                const feat = t(`landing.pricing.payg.feature${n}`);
                return (
                  <li key={feat} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 flex-shrink-0 text-primary" />
                    <span className="text-brand-ink">{feat}</span>
                  </li>
                );
              })}
            </ul>
            <Button 
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-medium rounded-full"
              onClick={onRegisterClick} 
              data-testid="pricing-payg-cta"
            >
              {t('landing.pricing.payg.cta')}
            </Button>
          </div>

          {/* Consultant Plan */}
          <div className="bg-white rounded-lg p-8 shadow-lg border border-border">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold mb-2 text-foreground">
                {t('landing.pricing.consultant.name')}
              </h3>
              <div className="text-5xl font-bold mb-2 text-foreground">
                {t('landing.pricing.consultant.price')}
              </div>
              <p className="text-muted-foreground">{t('landing.pricing.consultant.period')}</p>
              <p className="text-sm mt-2 text-muted-foreground">
                {t('landing.pricing.consultant.description')}
              </p>
            </div>
            <ul className="space-y-4 mb-8">
              {[1,2,3,4,5].map((n) => {
                const feat = t(`landing.pricing.consultant.feature${n}`);
                return (
                  <li key={feat} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 flex-shrink-0 text-primary" />
                    <span className="text-brand-ink">{feat}</span>
                  </li>
                );
              })}
            </ul>
            <Button 
              className="w-full border-border"
              variant="outline"
              onClick={onRegisterClick} 
              data-testid="pricing-consultant-cta"
            >
              {t('landing.pricing.consultant.cta')}
            </Button>
          </div>
        </div>
        
        {/* CAD note */}
        <p className="text-center mt-8 text-sm text-muted-foreground">
          {t('landing.pricing.cadNote')}
        </p>
      </div>
    </section>
  );
}
